const COMPANY = "Studio Nouvelle S.r.l.";
const ADDRESS = "Via Casa Manzo, 7 — 84135 Salerno (SA)";
const VAT = "02631750656";
const EMAIL = "pgiarletta@gmail.com";
const UPDATED = "1 ottobre 2026";

function Section({ title, children }) {
  return (
    <section className="space-y-2">
      <h2 className="text-lg font-semibold text-slate-100">{title}</h2>
      <div className="text-sm leading-relaxed text-slate-300 space-y-2">{children}</div>
    </section>
  );
}

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0A0E17] text-slate-200 py-12 px-4" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto space-y-8">
        <header className="space-y-2 border-b border-[#1F2937] pb-6">
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-100">Informativa sulla Privacy</h1>
          <p className="text-sm text-slate-400">{COMPANY} — Ultimo aggiornamento: {UPDATED}</p>
        </header>

        <Section title="1. Titolare del trattamento">
          <p>Il titolare del trattamento dei dati personali è <strong>{COMPANY}</strong>, con sede in {ADDRESS} — P.IVA e Codice Fiscale {VAT}. Per qualsiasi richiesta relativa alla privacy è possibile scrivere a <a href={`mailto:${EMAIL}`} className="text-[#10B981] underline">{EMAIL}</a>.</p>
        </Section>

        <Section title="2. Dati che raccogliamo">
          <p>Trattiamo i seguenti dati, forniti direttamente dall'utente o raccolti al momento dell'iscrizione al nostro servizio di comunicazioni:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Numero di telefono (WhatsApp);</li>
            <li>Nome o riferimento identificativo;</li>
            <li>Preferenze di consenso (iscrizione/disiscrizione) e relativa data;</li>
            <li>Dati tecnici relativi all'invio e alla ricezione dei messaggi (stati di consegna e lettura).</li>
          </ul>
        </Section>

        <Section title="3. Finalità e base giuridica">
          <p>I dati sono trattati per inviare comunicazioni commerciali, promozionali e di servizio tramite WhatsApp (ad esempio offerte, novità e aggiornamenti), esclusivamente previo <strong>consenso esplicito</strong> dell'interessato (art. 6, par. 1, lett. a GDPR). Il consenso può essere revocato in qualsiasi momento.</p>
        </Section>

        <Section title="4. WhatsApp e Meta">
          <p>Le comunicazioni avvengono tramite la piattaforma WhatsApp Business, fornita da Meta Platforms Ireland Ltd. L'invio dei messaggi comporta il trattamento del numero di telefono tramite l'infrastruttura di Meta, secondo le sue condizioni. Maggiori informazioni sono disponibili nell'informativa privacy di WhatsApp.</p>
        </Section>

        <Section title="5. Come revocare il consenso (opt-out)">
          <p>È possibile interrompere in qualsiasi momento la ricezione dei messaggi rispondendo con la parola <strong>STOP</strong> (oppure ANNULLA / CANCELLA) al messaggio ricevuto. La richiesta viene registrata immediatamente e non riceverai ulteriori comunicazioni promozionali.</p>
        </Section>

        <Section title="6. Conservazione dei dati">
          <p>I dati vengono conservati per il tempo necessario a fornire il servizio e fino alla revoca del consenso. In caso di disiscrizione, i dati identificativi vengono rimossi o resi anonimi, salvo obblighi di legge.</p>
        </Section>

        <Section title="7. Comunicazione dei dati">
          <p>I dati non vengono venduti a terzi. Possono essere trattati da fornitori tecnici che ci supportano nell'erogazione del servizio (ad esempio il fornitore della piattaforma di messaggistica), nel rispetto del GDPR.</p>
        </Section>

        <Section title="8. Diritti dell'interessato">
          <p>In base al GDPR hai diritto di accedere ai tuoi dati, rettificarli, cancellarli, limitarne il trattamento, opporti e richiederne la portabilità. Per esercitare questi diritti scrivi a <a href={`mailto:${EMAIL}`} className="text-[#10B981] underline">{EMAIL}</a>. Hai inoltre diritto di proporre reclamo all'Autorità Garante per la protezione dei dati personali.</p>
        </Section>

        <Section title="9. Cancellazione dei dati personali">
          <p>Per richiedere la cancellazione dei tuoi dati personali consulta la <a href="/data-deletion" className="text-[#10B981] underline" data-testid="privacy-data-deletion-link">procedura dedicata</a>, che indica le informazioni da fornire, le modalità di verifica e di gestione della richiesta e i casi in cui alcuni dati possono essere conservati per obblighi di legge.</p>
        </Section>

        <Section title="10. Modifiche">
          <p>La presente informativa può essere aggiornata nel tempo. Le modifiche saranno pubblicate su questa pagina con l'indicazione della data di ultimo aggiornamento.</p>
        </Section>

        <footer className="border-t border-[#1F2937] pt-6 text-xs text-slate-500">
          © {new Date().getFullYear()} {COMPANY}. Tutti i diritti riservati.
        </footer>
      </div>
    </div>
  );
}
